import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useCartCount } from '../context/CartCountContext';
import UserAvatar from './UserAvatar';
import './Navbar.css';

const Navbar: React.FC = () => {
  const { user } = useAuth();
  const { cartCount, refreshCartCount } = useCartCount();
  const location = useLocation();
  const isLandingPage = location.pathname === '/';
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  useEffect(() => {
    refreshCartCount();
  }, [refreshCartCount]);

  return (
    <nav className={`navbar ${isLandingPage ? 'navbar-transparent' : ''}`}>
      <div className="navbar-container">
        <Link to="/" className="navbar-brand" onClick={closeMobileMenu}>
          🛒 Club Kazi
        </Link>
        <button 
          className="mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span className={mobileMenuOpen ? 'hamburger open' : 'hamburger'}></span>
        </button>
        {user ? (
          <>
            <div className={`navbar-menu ${mobileMenuOpen ? 'mobile-open' : ''}`}>
              <Link to="/about" className="navbar-link" onClick={closeMobileMenu}>About</Link>
              <Link to="/products" className="navbar-link" onClick={closeMobileMenu}>Products</Link>
              <Link to="/cart" className="navbar-link cart-link" onClick={closeMobileMenu}>
                Cart
                {cartCount > 0 && <span className="cart-count-badge">{cartCount}</span>}
              </Link>
              <UserAvatar />
            </div>
          </>
        ) : (
          <div className={`navbar-menu ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            <Link to="/about" className="navbar-link" onClick={closeMobileMenu}>About</Link>
            <Link to="/products" className="navbar-link" onClick={closeMobileMenu}>Products</Link>
            <Link to="/login" className="navbar-link" onClick={closeMobileMenu}>Sign In</Link>
            <Link to="/register" className="btn-nav-primary" onClick={closeMobileMenu}>
              Join Now
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;

